<script lang="ts">
	import { OrderFulfillmentStatus, OrderFinancialStatus, GetSDSOnlyInfoStore } from '$houdini';
	import ReOrderButton from '$lib/components/Button/ReOrderButton.svelte';
	import RetoureButton from '$lib/components/Button/RetoureButton.svelte';
	import ViewOrderDetailsButton from '$lib/components/Button/ViewOrderDetailsButton.svelte';
	import ProductAddedToCartDrawer from '$lib/components/Drawer/ProductAddedToCartDrawer.svelte';
	import StoryblokImageOrVideo from '$lib/components/Image/StoryblokImageOrVideo.svelte';
	import { image_urlsAsArray } from '$lib/utils';
	import { formatIsoToDateString } from '$lib/utils/Date';
	import { classes } from '@thearc-hq/ui-kit/utils';
	import { T, getTranslate } from '@tolgee/svelte';
	import type { Order, OrderLine } from '$lib/types/Order/order';

	export let orderLineItem: OrderLine;
	export let additionalClass: string = '';

	const { t } = getTranslate();

	const order: Order = orderLineItem.order;
	const image: string = image_urlsAsArray(orderLineItem.variant?.image_urls?.value)[0];
	const orderFulfilled = order.fulfillmentStatus === OrderFulfillmentStatus.FULFILLED;
	const orderRefunded = order.financialStatus === OrderFinancialStatus.REFUNDED;
	let showAddedToCart = false;
	let selectedLineId: string | undefined = undefined;

	const handleVariantAddedToCart = (event: { detail: { lineId: string } }) => {
		selectedLineId = event.detail.lineId;
		showAddedToCart = true;
	};
</script>

<div
	class={classes(
		additionalClass,
		'flex flex-col justify-between gap-4 text-p-12 md:flex-row md:gap-8'
	)}
>
	<div class="flex flex-row items-start flex-1 gap-4 md:gap-8 md:items-center">
		<StoryblokImageOrVideo
			class="!w-[86px] !h-[86px] !max-w-[86px] !max-h-[86px] flex-0"
			src={image}
			layout="intrinsic"
			height={86}
			width={86}
		/>
		<div class="flex flex-col items-end flex-1 gap-1 md:flex-row md:gap-8">
			<div class="flex flex-col w-full gap-4 md:w-4/12">
				<p class="font-bold text-black text-h-16">{orderLineItem.title ?? ''}</p>
				<span>
					<T
						keyName="order.lineItem.orderedAt"
						params={{ date: formatIsoToDateString(orderLineItem.order.processedAt) }}
					/>
				</span>
			</div>
			<div class="flex flex-col w-full gap-1 md:gap-4 md:w-8/12">
				<p class={orderFulfilled ? 'text-special-success' : 'text-black'}>
					{orderFulfilled && !orderRefunded
						? `${$t(
								`orderStateMapping.${orderLineItem.order.fulfillmentStatus}`
							)}: ${formatIsoToDateString(orderLineItem.order.processedAt)}`
						: orderRefunded
							? $t('orderStateMapping.refunded')
							: $t(`orderStateMapping.${orderLineItem.order.fulfillmentStatus}`)}
				</p>
				<span>{$t('orders.orderNumber', { orderNumber: orderLineItem.order.orderNumber })}</span>
			</div>
		</div>
	</div>
	<div class="flex flex-row items-center justify-around md:flex-col md:items-end md:justify-center">
		<ViewOrderDetailsButton orderNumber={orderLineItem.order.orderNumber} />

		{#if orderLineItem.variant}
			<ReOrderButton
				variant={orderLineItem.variant}
				on:variantAddedToCart={async (event) => handleVariantAddedToCart(event)}
			/>
		{/if}
		<RetoureButton additionalClass="-mr-4 py-2" />
	</div>
</div>
{#if selectedLineId && showAddedToCart}
	<ProductAddedToCartDrawer bind:expanded={showAddedToCart} lineIds={[selectedLineId]} />
{/if}
